export enum Period {
    AM = "AM",
    PM = "PM", 
}